export default __webpack_public_path__ + "static/media/dep3_0.0a367db4.png";